import { render, staticRenderFns } from "./ZipCodeConfirmPopup.vue?vue&type=template&id=98ed7d9c&scoped=true&"
import script from "./ZipCodeConfirmPopup.vue?vue&type=script&lang=js&"
export * from "./ZipCodeConfirmPopup.vue?vue&type=script&lang=js&"
import style0 from "./ZipCodeConfirmPopup.vue?vue&type=style&index=0&id=98ed7d9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ed7d9c",
  null
  
)

export default component.exports